import { useQuery } from '@tanstack/react-query';
import { planApi } from '@/api/planApi';

/**
 * 다운그레이드 적용일 정책 조회(GET /api/public/plan-policy, 인증 불필요) -
 * TermsModal.tsx(로그인 전에도 노출)/PlanPage.tsx 양쪽이 이 훅 하나만 써서
 * "한쪽만 고치고 다른 쪽을 놓치는" 재발을 막는다(2026-08-03 BE
 * estimatedDowngradeEffectiveDate 통일과 동일한 이유).
 *
 * API 실패/로딩 중에는 nonEnterpriseDowngradeAppliesFirstOfMonth를 알 수 없으므로
 * undefined를 반환한다 - 호출부는 downgradePolicyText.ts의 폴백 문구를 쓴다.
 */
export function useDowngradePolicy() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['planPolicy'],
    queryFn: async () => (await planApi.getPlanPolicy()).data,
    staleTime: 5 * 60 * 1000,
  });

  return {
    nonEnterpriseDowngradeAppliesFirstOfMonth: data?.nonEnterpriseDowngradeAppliesFirstOfMonth,
    isLoading,
    isError,
  };
}
